import Image from 'next/image'
import Link from 'next/link'
import React from 'react'
import XTwitterLogo from 'src/assets/X-Twitter_Black.svg'

interface IconLinkProps {
  url: string
  title?: string
}

export const IconLinkTwitter: React.FC<IconLinkProps> = ({ url = '', title = '' }) => {
  return (
    <Link
      href={url}
      target="_blank"
      className="flex flex-row items-center cursor-pointer mr-[0.625rem] font-primary text-[16px] font-bold !color-"
      title={title}
    >
      <Image src={XTwitterLogo} width={16} height={16} alt="X-Twitter" className="mr-[0.2rem]" />
    </Link>
  )
}
